export {
  default,
  getServerSideProps,
} from '@kamernet/modules/Commons/pages/HomeLandlord/HomeLandlord.page';
